var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHugeiconsTrampoline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    color: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 10v8m10-2v4m10-10v8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 10,
    rx: 10,
    ry: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsTrampoline);
export default __webpack_public_path__ + "static/media/hugeicons--trampoline.2ba79614d669e83abd51dadfa4c564f6.svg";
export { ForwardRef as ReactComponent };